export function CalculaDesconto(valor: number, desconto: number) {
    const descontoCalculado = valor - (valor * (desconto / 100))
    return descontoCalculado;
}